import React from 'react'
import ProductCreate from '../components/ProductCreate'

function ProductCreatePage() {
  return (
    <div>
      <ProductCreate/>
    </div>
  )
}

export default ProductCreatePage
